import { getReceipt } from 'api/Transaction';

export const fetchKioskReceipt = async (navigate, transactionId) => {
  if (!transactionId) return null;
  const response = await getReceipt(navigate, { transactionId });
  return response?.code === 0 ? response.receipt || null : null;
};
